







































































import { Vue, Component, Prop } from 'vue-property-decorator'
import * as echarts from 'echarts/lib/echarts'
import 'echarts/lib/chart/radar'
import html2canvas from 'html2canvas'
import shareMod from '../comps/shareMod.vue'
import showDiv, { closeAll } from '@ivy/fts/showDiv'
import * as utils from '@ivy/fts/utils'
@Component({
  components: {},
})
export default class TalantTestResult extends Vue {
  @Prop({ default: [] }) result
  myChart
  userInfo: any = {}
  status = 'drawing'
  saveImageSrc
  showMoreInfo = true
  get talentMod() {
    let mods = this.result.filter(m => m.isHighest)
    if (mods[0] && mods[0].score === 0) mods = []
    return mods
  }
  get qrText() {
    return this.status === 'drawing' ? '长按识别二维码' : '长按保存图片'
  }
  get avartarUrl() {
    if (this.userInfo.headimgurl)
      return `/api/mobile/tool/proxy?url=${this.userInfo.headimgurl}`
    if (!this.userInfo.user || !this.userInfo.user.avatar_url) return ''
    return `/api/mobile/tool/proxy?url=${this.userInfo.user.avatar_url}`
  }
  get babyNick() {
    if (this.userInfo.user && this.userInfo.user.baby_nick)
      return this.userInfo.user.baby_nick
    return '宝贝'
  }
  async mounted() {
    await this.$store.login()
    this.userInfo = this.$store.logined || {}
    if (this.talentMod.length) this.paintCanvas()
    setTimeout(() => {
      this.toImage()
    }, 1000)
  }
  paintCanvas() {
    if (!this.result.length) return
    let indicator = []
    let values = []
    this.result.forEach(mod => {
      indicator.push({
        name: mod.mod,
        max: mod.total,
      })
      values.push(mod.score || 0)
    })
    this.myChart = echarts.init(this.$refs.canvas)
    let options = {
      grid: {
        left: 0,
      },
      tooltip: {},
      radar: {
        // shape: 'circle',
        name: {
          textStyle: {
            color: '#fff',
            fontWeight: 600,
            fontSize: 11,
            backgroundColor: '#1868A2',
            borderRadius: 15,
            padding: [3, 8, 3, 8],
          },
        },
        nameGap: 6,
        splitNumber: 10,
        splitLine: {
          lineStyle: {
            color: [
              '#ccc',
              '#ccc',
              '#ccc',
              '#ccc',
              '#ccc',
              '#ccc',
              '#ccc',
              '#ccc',
              '#ccc',
              '#ccc',
              '#888',
            ],
            width: 1,
          },
        },
        splitArea: {
          areaStyle: {
            color: '#fff',
          },
        },
        axisLine: {
          lineStyle: {
            color: '#979797',
            width: 1,
          },
        },
        indicator,
      },
      series: [
        {
          name: '结果评测',
          type: 'radar',
          symbolSize: 8,
          lineStyle: {
            color: '#57ccf4',
            width: 2,
          },
          areaStyle: {
            color: 'rgba(87,204,244,0.50)',
          },
          itemStyle: {
            color: '#57CCF4',
            borderWidth: 2,
          },
          data: [
            {
              value: values,
            },
          ],
        },
      ],
    }
    this.myChart.setOption(options)
  }
  toImage() {
    let opts = {
      // dpi: window.devicePixelRatio * 4,
      // scale: 8, // 添加的scale 参数
      // canvas: document.getElementById('canvas'), // 自定义 canvas
      // logging: true, // 日志开关，便于查看html2canvas的内部执行流程
      // width: 750, // dom 原始宽度
      // height: 1243,
      useCORS: true, // 【重要】开启跨域配置
    }
    html2canvas(document.getElementById('talentResultContainer'), opts).then(
      canvas => {
        // 将canvas转化成base64图片
        let tempSrc = canvas.toDataURL('image/png')
        // 将base64传给img标签
        this.saveImageSrc = tempSrc
        this.status = 'finished'
      }
    )
  }
  toMorePage() {
    window.location.href = 'https://mp.weixin.qq.com/s/pr0Svjs0tMkjYE7FQNAfDQ'
  }
  showShareMod() {
    showDiv(shareMod, {
      texts: ['分享给好友', '测一测Ta家宝宝身上隐藏了什么天赋~'],
    })
  }
}
